<aside class="main-sidebar sidebar-dark-primary auction-sidebar">
  <div class="auction-logo-wrapper">
    <img src="/assets/img/auction_system_logo.png" alt="Marketplace Auction & Exchange" class="auction-logo-img"/>
  </div>
  <div class="sidebar auction-sidebar-inner">
    <nav class="auction-nav">
      <ul class="nav nav-pills nav-sidebar flex-column auction-nav-list py-3" data-widget="treeview">

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a class="nav-link auction-nav-link" routerLink="/dashboard" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon icon-lg mr-2"><ion-icon name="grid-outline"></ion-icon></span>
            <p>Dashboard</p>
          </a>
        </li>

        <li class="nav-section-label" *ngIf="
          ['Super Admin','Logistic Admin','Auction controller','Management','Media Admin','Sales Admin','Marketing Admin'].includes(role)
        ">
          <span>Management</span>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="
            ['Super Admin','Logistic Admin','Auction controller','Management','Media Admin'].includes(role)
          ">
          <a href="javascript:void(0)" class="nav-link auction-nav-link"
            (click)="isInventoryCollapse = !isInventoryCollapse">
            <span class="icon icon-lg mr-2"><ion-icon name="cube-outline"></ion-icon></span>
            <p>Inventory</p>
            <span class="nav-toggle-icon ml-auto">{{ isInventoryCollapse ? '−' : '+' }}</span>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isInventoryCollapse" [isAnimated]="true">
            <li class="nav-item">
              <a class="nav-link" routerLink="/dashboard/inventory"
                [queryParams]="{ type: 'vehicle', page: 1, limit: 10 }" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <span>Auction</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/dashboard/inventory/retail" [queryParams]="{ type: 'available' }"
                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <span>Retail</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/dashboard/inventory/new" routerLinkActive="active"
                [queryParams]="{ type: 'available' }" [routerLinkActiveOptions]="{ exact: true }">
                <span>New</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" routerLink="/dashboard/inventory/purchase" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <span>Retail Purchase Request</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="
            ['Super Admin','Sales Admin','Auction controller','Marketing Admin','Management'].includes(role)
          ">
          <a class="nav-link auction-nav-link" routerLink="/dashboard/auction" [queryParams]="{ type: 'individual' }"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon icon-lg mr-2"><ion-icon name="hammer-outline"></ion-icon></span>
            <p>Auctions</p>
          </a>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="
            ['Super Admin','Logistic Admin','Auction controller','Management','Media Admin'].includes(role)
          ">
          <a href="javascript:void(0)" class="nav-link auction-nav-link"
            (click)="isAuctionsCollapse = !isAuctionsCollapse">
            <span class="icon icon-lg mr-2"><ion-icon name="pricetags-outline"></ion-icon></span>
            <p>Auctions2</p>
            <span class="nav-toggle-icon ml-auto">{{ isAuctionsCollapse ? '−' : '+' }}</span>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isAuctionsCollapse" [isAnimated]="true">
            <li class="nav-item"><a class="nav-link" routerLink="auction/create" [queryParams]="{ type: 'bulk' }"
                routerLinkActive="active"><span>Create</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="auction/instant" [queryParams]="{ page: 1, limit: 10 }"
                routerLinkActive="active"><span>Instant</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="auction/individual"
                [queryParams]="{ page: 1, limit: 10 }" routerLinkActive="active"><span>Individual</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="auction/bulk" [queryParams]="{ page: 1, limit: 10 }"
                routerLinkActive="active"><span>Bulk</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="auction/timed-individual"
                [queryParams]="{ tab: 'inventory', page: 1, limit: 10 }"
                routerLinkActive="active"><span>Timed-Individual</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="auction/batch"
                routerLinkActive="active"><span>Batch</span></a></li>
          </ul>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="
            ['Super Admin','Logistic Admin','Auction controller','Management','Media Admin'].includes(role)
          ">
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isBuyersCollapse = !isBuyersCollapse">
            <span class="icon icon-lg mr-2"><ion-icon name="people-outline"></ion-icon></span>
            <p>Buyers</p>
            <span class="nav-toggle-icon ml-auto">{{ isBuyersCollapse ? '−' : '+' }}</span>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isBuyersCollapse" [isAnimated]="true">
            <li class="nav-item"><a class="nav-link" routerLink="buyers/auction"
                [queryParams]="{ tab: 'bulk', page: 1, limit: 10 }" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Auction</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="buyers/retail" [queryParams]="{ page: 1, limit: 10 }"
                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><span>Retail</span></a></li>
          </ul>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="
            ['Super Admin','Sales Admin','Auction controller','Marketing Admin','Management'].includes(role)
          ">
          <a class="nav-link auction-nav-link" routerLink="/dashboard/calendar" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon icon-lg mr-2"><ion-icon name="calendar-outline"></ion-icon></span>
            <p>Calendar</p>
          </a>
        </li>

        <li class="nav-section-label" *ngIf="['Super Admin', 'Management'].includes(role)">
          <span>User</span>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a class="nav-link auction-nav-link" href="javascript:void(0)" (click)="isUserCollapse = !isUserCollapse">
            <span class="icon icon-lg mr-2"><ion-icon name="person-outline"></ion-icon></span>
            <p>User</p>
            <span class="nav-toggle-icon ml-auto">{{ isUserCollapse ? '−' : '+' }}</span>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isUserCollapse" [isAnimated]="true">
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/user" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>User</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/user/pdi" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>PDI</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/user/add-user" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Add User</span></a></li>
          </ul>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="
            ['Super Admin','Sales Admin','Auction controller','Accounts Admin','Accounts Manager','Marketing Admin','Management'].includes(role)
          ">
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isCollapse = !isCollapse">
            <span class="icon icon-lg mr-2"><ion-icon name="settings-outline"></ion-icon></span>
            <p>Settings</p>
            <span class="nav-toggle-icon ml-auto">{{ isCollapse ? '−' : '+' }}</span>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isCollapse" [isAnimated]="true">
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)"><a class="nav-link"
                routerLink="/dashboard/settings/email-templates" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Email templates</span></a></li>
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)"><a class="nav-link"
                routerLink="/dashboard/settings/sms-templates" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>SMS template</span></a></li>
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)"><a class="nav-link"
                routerLink="/dashboard/settings/api-management" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>API key management</span></a></li>
            <li class="nav-item" *ngIf="
                ['Super Admin','Sales Admin','Auction controller','Accounts Admin','Accounts Manager','Marketing Admin','Management'].includes(role)
              "><a class="nav-link" routerLink="/dashboard/settings/system" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>System Settings</span></a></li>
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)"><a
                routerLink="/dashboard/settings/user-roles" class="nav-link" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>User roles</span></a></li>
          </ul>
        </li>

        <li class="nav-section-label" *ngIf="['Super Admin', 'Management', 'Operation Admin'].includes(role)">
          <span>Apps</span>
        </li>

        <!-- <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isCMSCollapse = !isCMSCollapse">
            <span class="icon icon-lg mr-2"><ion-icon name="document-text-outline"></ion-icon></span>
            <p>CMS pages</p>
            <span class="nav-toggle-icon ml-auto">{{ isCMSCollapse ? '−' : '+' }}</span>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isCMSCollapse" [isAnimated]="true">
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Home</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/common" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Common</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/review" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Review</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/services" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Services</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/finance" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Finance</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/sell" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Sell</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/trade" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Trade</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/auction" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Auction</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/faq" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>FAQ</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/email" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Email</span></a></li>
            <li class="nav-item"><a class="nav-link" routerLink="/dashboard/cms/buy" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"><span>Buy</span></a></li>
          </ul>
        </li> -->

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a routerLink="/dashboard/customer-request" class="nav-link auction-nav-link" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon icon-lg mr-2"><ion-icon name="call-outline"></ion-icon></span>
            <p>Contacts</p>
          </a>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a class="nav-link auction-nav-link" routerLink="/dashboard/comments" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span class="icon icon-lg mr-2"><ion-icon name="chatbox-ellipses-outline"></ion-icon></span>
            <p>Reviews</p>
          </a>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Operation Admin', 'Management'].includes(role)">
          <a routerLink="/dashboard/reports" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link auction-nav-link">
            <span class="icon icon-lg mr-2"><ion-icon name="bar-chart-outline"></ion-icon></span>
            <p>Auction Purchase Request</p>
          </a>
        </li>

      </ul>
    </nav>
  </div>
</aside>